import React from 'react'

import * as S from './styles'
import IProps from './props'

const publicDir = process.env.PUBLIC_URL

const WelcomeModal = ({ isModalOpen, handleCloseModal }: IProps) => {
  if (!isModalOpen) {
    return null
  }

  return (
    <S.Container>
      <S.Content>
        <S.VideoContainer>
          <S.Video controls autoPlay>
            <source src={`${publicDir}/midia/welcome.mp4`} type="video/mp4" />
            <source src={`${publicDir}/midia/welcome.webm`} type="video/webm" />
            <source src={`${publicDir}/midia/welcome.ogv`} type="video/ogv" />
            Seu navegador não suporta o elemento
            {' '}
            <code>video</code>
            .
          </S.Video>
        </S.VideoContainer>
        <S.TextsContainer>
          <S.FirstText>
            <span>Bem vindo,</span>
            {' '}
            agora você faz parte da maior plataforma de
            busca por médicos do Brasil
          </S.FirstText>
          <S.SecondText>
            Por favor
            {' '}
            <span>
              Assista ao vídeo acima para conhecer um pouco mais sobre nós!
            </span>
          </S.SecondText>
          <S.ThirdText>Clique em Ok para acessar a plataforma.</S.ThirdText>
        </S.TextsContainer>
        <S.ConfirmButton onClick={handleCloseModal}>Ok</S.ConfirmButton>
      </S.Content>
    </S.Container>
  )
}

export default WelcomeModal
